import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { TitleService } from '../../core/services/title.service';
import { ChatService } from '../../core/services/chat.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatDetailTitleResolver implements Resolve<any> {
  constructor(
    private titleService: TitleService,
    private chatService: ChatService,
  ) {}
  
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const chatId = parseInt(route.paramMap.get('chatId') || '0', 10);

    const t = 'Chat';
    this.titleService.setTitle(t);

    if (chatId) {
      return this.chatService.getChatMetadata(chatId);
    }
    
    return new Observable(observer => observer.next(null));
  }
}
